import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getActiveTrackersDashboardDatasRedux = createAsyncThunk(
    "dashboard/getActiveTrackers",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/trackers-list`,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getDestinationsDashboardDatasRedux = createAsyncThunk(
    "dashboard/getAvtiveDestinations",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/destinations?active=1`,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getSourcesDashboardDatasRedux = createAsyncThunk(
    "dashboard/getActiveSources",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/sources?active=1`,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getBusinessAsync = createAsyncThunk(
    "dashboard/getBusiness",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/user/businesses`,
            RequestConfig(),
        );
        return response.data;
    },
);
